<template>
  <b-row class="confirmation">
    <b-col class="phone">
      <img :src="phoneImage"/>
    </b-col>
    <b-col class="thanks">
      <h1>Thanks!<br/>You're all set.</h1>
      <p class="mt-3">We’ll be in touch when we have news.</p>
      <div class="splash">
        <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="95" height="95" viewBox="0 0 95 95"><defs><linearGradient id="a" x1="89.409%" x2="9.003%" y1="8.574%" y2="90.704%"><stop offset="0%" stop-color="#A01291"/><stop offset="35.518%" stop-color="#BE1470"/><stop offset="53.115%" stop-color="#D1155C"/><stop offset="81.237%" stop-color="#F15E2F"/><stop offset="100%" stop-color="#F8A74D"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><path fill="#000" d="M70.917 61.058c-4.676 8.064-13.4 13.489-23.394 13.489-14.924 0-27.023-12.1-27.023-27.023C20.5 32.599 32.6 20.5 47.523 20.5c9.99 0 18.714 5.422 23.39 13.483l-9.074 5.24c-2.866-4.931-8.202-8.25-14.316-8.25-9.14 0-16.55 7.41-16.55 16.55s7.41 16.55 16.55 16.55c6.117 0 11.455-3.32 14.32-8.255 4.674-8.07 13.402-13.5 23.4-13.5h3.927C86.616 21.57 68.94 5.5 47.5 5.5c-23.196 0-42 18.804-42 42s18.804 42 42 42c21.402 0 39.052-16.012 41.656-36.707h-3.914c-6.12 0-11.462 3.325-14.325 8.265"/><path fill="#F0F0F0" d="M85.242 42.32c-9.998 0-18.726 5.428-23.4 13.497-2.864 4.935-8.201 8.256-14.319 8.256-9.14 0-16.55-7.41-16.55-16.55s7.41-16.55 16.55-16.55c6.114 0 11.45 3.318 14.316 8.25l9.075-5.24C66.236 25.92 57.514 20.5 47.523 20.5 32.599 20.5 20.5 32.6 20.5 47.523c0 14.925 12.098 27.023 27.022 27.023 9.993 0 18.718-5.424 23.395-13.488 2.862-4.94 8.203-8.265 14.323-8.265h3.915c.218-1.735.344-3.499.344-5.293 0-1.756-.12-3.482-.33-5.18h-3.928z"/><path fill="url(#a)" d="M47.5 0C73.733 0 95 21.267 95 47.5 95 73.734 73.733 95 47.5 95 21.266 95 0 73.734 0 47.5 0 21.267 21.266 0 47.5 0zM3 47.5C3 72.077 22.923 92 47.5 92S92 72.077 92 47.5 72.077 3 47.5 3 3 22.923 3 47.5z"/></g></svg>
        <h2 v-if="$root.isMobile">
          Discover amazing artists
          <br/>
          and track their travels
          <br/>
          by following <a href="https://www.instagram.com/we_are_coal/" target="_blank" ref="link">@we_are_coal</a>
          <br/>
          on Instagram.
        </h2>
        <h2 v-else>
          Discover amazing artists
          <br/>
          and track their travels by following
          <br/>
          <a href="https://www.instagram.com/we_are_coal/" target="_blank" ref="link">@we_are_coal</a>
          on Instagram.
        </h2>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Confirmation',
  mounted() {
  },
  computed: {
    phoneImage() {
      return `${process.env.VUE_APP_STORAGE_BUCKET}/app/phone.png`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/css/variables';

  .splash {
    background: transparent url('/splash.png') no-repeat;
    background-size: cover;
    margin: 80px -$side-margin 0px -$side-margin;
    padding: 30px $side-margin 30px;

    h2 {
      margin-top: 20px;
      color: $white;
    }

    a, a:visited, a:active, a:focus {
      color: $yellow;
      font-size: inherit;
      font-family: inherit;
    }
  }

  .mobile {
    .phone {
      display: none;
    }
  }

  .desktop {

    h1 {
      color: #f0f0f0;
    }

    .row {
      max-width: 777px;
      margin: 0 auto;
      margin-top: calc(50vh - 300px - 145px);
    }

    .phone {
      width: 302px;
      height: 654px;
      max-width: 302px;
      padding: 0px;
      margin-right: 63px;
    }

    .thanks {
      max-width: 412px;
      padding: 0;
      align-self: center;
    }

    .splash {
      background: none;
      border-top: 1px solid #282828;
      margin: 40px 0 0 0 ;
      padding: 39px 0 0 0;

      h2 {
        font-size: 24px;

        a:hover {
          color: #f0f0f0;
        }
      }
    }
  }
</style>
